import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

// Full URL: /admissions/:unitId/adminPortal/stagesAndStatuses.
export default store => ({
  path: "stagesAndStatuses",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "admissions-admin-portal" */ "Admissions/features/AdminPortal/components/StagesAndStatusesPage"
    ).then(m => m.default)
  ),
});
